import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import StyledTooltip from "../../components/Wrapper/StyledTooltip";
import { tesaGrey2 } from "../../styles/colors";

const useStyles = makeStyles({
  rootBox: { display: "flex", flexDirection: "row", alignItems: "center" },
  infoIcon: {
    fontSize: "1rem",
    color: tesaGrey2,
    cursor: "help",
  },
  textSpan: { fontSize: "12px", marginRight: "10px" },
});

const MultipleTextFieldHelperText = () => {
  const classes = useStyles();

  return (
    <Box className={classes.rootBox} component="span">
      <span className={classes.textSpan}>Does not search in all input fields</span>
      <StyledTooltip
        title="The following fields are searched: Background Information, Current Solution, Test Program,
                        Process Detail, Request Title, Request ID, Requester, Responsible"
      >
        <InfoOutlinedIcon className={classes.infoIcon} />
      </StyledTooltip>
    </Box>
  );
};

export default MultipleTextFieldHelperText;
